import {
  Component,
  ViewChild,
  AfterViewInit,
  OnInit,
  Input,
  NgZone,
  ElementRef,
  OnChanges,
  SimpleChanges,
  AfterViewChecked, AfterContentInit, AfterContentChecked, OnDestroy
} from '@angular/core';
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid';
import { jqxSchedulerComponent } from 'jqwidgets-ng/jqxscheduler';
import {from, Observable, ObservedValueOf, of, Subject} from 'rxjs';
import {CalendarDataService} from '../service/calendar-data.service';
import { WebsocketDataService } from '../service/websocket-data.service';
import {AsyncObservableComponent} from '../async-observable/async-observable.component';
import { catchError, tap, map } from 'rxjs/operators';
import {webSocket, WebSocketSubject} from 'rxjs/webSocket';
// export const WS_ENDPOINT = 'wss://5xsn8ribf6.execute-api.eu-central-1.amazonaws.com/dev';
import _ from 'underscore';
// import * as jq from 'jqwidgets-ng/jqwidgets/jqxexport';
import * as jq from 'jqwidgets-ng/jqwidgets/jqxscheduler';

// ALC adding pubsub
import Amplify, { PubSub } from 'aws-amplify';
// import { AWSIoTProvider } from '@aws-amplify/pubsub';
import {AnonymousSubject} from 'rxjs/internal-compatibility';
import * as DynamoDB from 'aws-sdk/clients/dynamodb';
import {DocumentClient} from 'aws-sdk/lib/dynamodb/document_client';
import {AuthService} from '../auth/auth.service';
// import * as $ from 'jquery';
import * as AWS from 'aws-sdk/global';
import * as alclocalization from './localization';

/*import {AppComponent} from '../app.component';*/
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css'],
})
export class HomeComponent implements AfterViewInit, OnInit, OnChanges, AfterViewChecked, AfterContentInit, AfterContentChecked, OnDestroy {
  title = 'alc-angular-app';
  // @Input() identityAuthorized = false;
  // public response: Observable<any>; // response: string;
  @Input() public response: string;
  // @Input() public time: string;
  @ViewChild('schedulerReference', { static: false }) scheduler: jqxSchedulerComponent;
  /*@ViewChild('identityAuthorized') */ // identityAuthorized = false; //  : ElementRef;
  sourceScheduler: any =
    {
      dataType: 'array',
      dataFields: [
        { name: 'id', type: 'string' },
        { name: 'description', type: 'string' },
        { name: 'location', type: 'string' },
        { name: 'subject', type: 'string' },
        { name: 'calendar', type: 'string' },
        { name: 'start', type: 'date' },
        { name: 'end', type: 'date' }
      ],
      id: 'id',
      localData: [] // this.generateAppointments()
    };
  @Input() dataAdapter: any = {}; // new jqx.dataAdapter(this.sourceScheduler);
  date: any = new jqx.date(2020, 11, 23, );
  appointmentDataFields: any =
    {
      from: 'start',
      to: 'end',
      id: 'id',
      description: 'description',
      location: 'location',
      subject: 'subject',
      resourceId: 'location'
    };
  resources: any =
    {
      colorScheme: 'scheme05',
      dataField: 'location',
      source: new jqx.dataAdapter(this.sourceScheduler) // this.sourceScheduler.localData
    };
  views: any[] =
    [
      { type: 'dayView', timeRuler: { scale: 'hour', formatString: 'HH:mm' }},
      { type: 'weekView', timeRuler: { scale: 'hour', formatString: 'HH:mm' }},
      { type: 'monthView', timeRuler: { scale: 'hour', formatString: 'HH:mm' }},
      { type: 'agendaView', timeRuler: { scale: 'hour', formatString: 'HH:mm' }},
    ];
  // ALC disply a number of LiveData$ subscribed to websocket subject
  webSocketSubscribers = 0;
  liveData$ = this.service.messages$.pipe(
    map(rows => {
      return rows.Records;
    }), // .records
    catchError(error => {
      console.log(error);
      throw error;
    }),
    tap({
        error: error => console.log('[Live component] Error:', error),
        complete: () => console.log('[Live component] Connection Closed')
      }
    )
  ) as Subject<any> ;
  @ViewChild('myLog', { static: false }) myLog: ElementRef;
  @ViewChild ('grid', { static: false }) grid: jqxGridComponent;
  @ViewChild ('timeticker', { static: false }) timeticker: AsyncObservableComponent;

  columns = [
    {text: 'Id', datafield: 'id'},
    {text: 'Name', datafield: 'name'}
  ];
  sourceGrid = new jqx.dataAdapter({
    localData: [
      {id: 1, name: 'Hydrogen'},
      {id: 2, name: 'Helium'},
      {id: 3, name: 'Lithium'},
      {id: 4, name: 'Beryllium'},
      {id: 5, name: 'Boron'},
      {id: 6, name: 'Carbon'},
      {id: 7, name: 'Nitrogen'},
      {id: 8, name: 'Oxygen'},
      {id: 9, name: 'Fluorine'},
      {id: 10, name: 'Neon'},
      {id: 11, name: 'Sodium'},
      {id: 12, name: 'Magnesium'},
      {id: 13, name: 'Aluminum'},
      {id: 14, name: 'Silicon'},
      {id: 15, name: 'Phosphorus'},
      {id: 16, name: 'Sulfur'},
      {id: 17, name: 'Chlorine'},
      {id: 18, name: 'Argon'},
      {id: 19, name: 'Potassium'},
      {id: 20, name: 'Calcium'}
    ]
  });
  // subject: WebSocketSubject<any>;
  private userObserver /*: Observer<CognitoUserInterface>*/ = {
    next: (data) => {
      // this.zone.run(() => {this.response =  x.toString(); });
      const telegramid = data.attributes['custom:telegramid'] || '';
      if (telegramid){
        this.calendarDataService.addUser(telegramid);
      }
    },
    error: (err) => {
      console.log(err);
    },
    complete: () => {
      // this.calendarDataLoaded = true;
      console.log('complete');
    }
  };
  private calendarDataLoaded = false;
  private calendarDataObserver = {
    next: (arr) => {
      console.log(arr);
      // this.zone.run(() => {this.response =  x.toString(); });
      this.addAppointments(arr);
    },
    error: ( err ) => {
      console.log(err);
    },
    complete: () => {
      // this.calendarDataLoaded = true;
      console.log('ALC. all items received fromm DynamoDB are processed now');
    }
  };
  public calendarLocalization = alclocalization;
  generateAppointments(): any {
    const appointments = [];
    const appointment1 = {
      id: 'id1',
      description: 'George brings projector for presentations.',
      location: 'location 1',
      subject: 'Quarterly Project Review Meeting',
      calendar: 'Room 1',
      start: new Date(2020, 10, 23, 9, 0, 0),
      end: new Date(2020, 10, 23, 16, 0, 0)
    };
    const appointment2 = {
      id: 'id2',
      description: '',
      location: 'location 10',
      subject: 'IT Group Mtg.',
      calendar: 'Room 2',
      start: new Date(2020, 10, 24, 10, 0, 0),
      end: new Date(2020, 10, 24, 15, 0, 0)
    };
    const appointment3 = {
      id: 'id3',
      description: '',
      location: 'location 1000',
      subject: 'Course Social Media',
      calendar: 'Room 3',
      start: new Date(2020, 10, 27, 11, 0, 0),
      end: new Date(2020, 10, 27, 13, 0, 0)
    };
    const appointment4 = {
      id: 'id4',
      description: '',
      location: 'location 10000',
      subject: 'New Projects Planning',
      calendar: 'Room 2',
      start: new Date(2020, 10, 23, 16, 0, 0),
      end: new Date(2020, 10, 23, 18, 0, 0)
    };
    const appointment5 = {
      id: 'id5',
      description: '',
      location: 'location 10',
      subject: 'Interview with James',
      calendar: 'Room 1',
      start: new Date(2020, 10, 25, 15, 0, 0),
      end: new Date(2020, 10, 25, 17, 0, 0)
    };
    const appointment6 = {
      id: 'id6',
      description: '',
      location: 'location 1000',
      subject: 'Interview with Nancy',
      calendar: 'Room 4',
      start: new Date(2020, 10, 26, 14, 0, 0),
      end: new Date(2020, 10, 26, 16, 0, 0)
    };
    appointments.push(appointment1);
    appointments.push(appointment2);
    appointments.push(appointment3);
    appointments.push(appointment4);
    appointments.push(appointment5);
    appointments.push(appointment6);
    return appointments;
  }
  schedulerReferenceOnAppointmentDelete(event: any): void {
    const appointment = event.args.appointment;
    this.calendarDataService.deleteAppointment(event.args.appointment.id).subscribe(data => {
      console.log(`home.component.ts => the appointement ${event.args.appointment.id} is deleted, response returned ${data}`);
    },
      err => {
        console.log(`home.component.ts => the appointement ${event.args.appointment.id} delete error ${err}`);
      });
    this.myLog.nativeElement.innerHTML = 'home.component.ts => appointmentDelete is raised';
  }
  schedulerReferenceOnAppointmentAdd(event: any): void {
    const appointment = event.args.appointment;
    this.myLog.nativeElement.innerHTML = 'appointmentAdd is raised';
  }
  schedulerReferenceOnAppointmentDoubleClick(event: any): void {
    const appointment = event.args.appointment;
    this.myLog.nativeElement.innerHTML = 'appointmentDoubleClick is raised';
  }
  schedulerReferenceOnAppointmentChange(event: any): void {
    const appointment = event.args.appointment;
    this.myLog.nativeElement.innerHTML = 'appointmentChange is raised';
  }
  schedulerReferenceOnCellClick(event: any): void {
    const cell = event.args.cell;
    this.myLog.nativeElement.innerHTML = 'cellClick is raised';
  }
  schedulerViewChange(event: any): void {
    const cell = event.args.cell;
    this.myLog.nativeElement.innerHTML = 'ViewChange is raised';
  }
  constructor(public calendarDataService: CalendarDataService, private zone: NgZone,
              public service: WebsocketDataService, private authService: AuthService) {
     // this.subject = webSocket(this.service.wsEndpoint);
  }
/*  addAppointment(day: number): void{
    const roomNumber = (day % 3) + 1;
    const dayNumber =  day % 23 + 1;
    const appId = 'day' + dayNumber;
    const subjectId = 'Subject' + dayNumber;
    const app = {
      id: appId,
      description: '',
      location: '',
      subject: subjectId,
      calendar: 'Room ' + roomNumber,
      start: new Date(2021, 10, dayNumber, dayNumber, 0, 0),
      end: new Date(2021, 10, dayNumber, dayNumber, 59, 0)
    };
    this.sourceScheduler.localData.push(app);
    this.dataAdapter.dataBind();
    this.scheduler.ensureAppointmentVisible(appId);
    this.scheduler.widgetObject.refresh();
  }*/

  addAppointments(arr): void{
    this.scheduler.beginAppointmentsUpdate();
    from(arr).subscribe((v: Array<any>) => {
      // this.scheduler.addAppointment(v);
      this.sourceScheduler.localData.push(...v);
    },
      err => {
      console.log(err);
      },
      () => {
        this.scheduler.endAppointmentsUpdate();
        /*const arrApps = this.scheduler.getDataAppointments();
        this.scheduler.attrSource =
          {
            dataType: 'array',
            dataFields: [
              { name: 'id', type: 'string' },
              { name: 'description', type: 'string' },
              { name: 'location', type: 'string' },
              { name: 'subject', type: 'string' },
              { name: 'calendar', type: 'string' },
              { name: 'start', type: 'date' },
              { name: 'end', type: 'date' }
            ],
            id: 'id',
            localData: JSON.parse(JSON.stringify(arrApps))
          };
        this.dataAdapter = new jqx.dataAdapter(this.sourceScheduler);
        this.scheduler.attrResources = {
            colorScheme: 'scheme05',
            dataField: 'location',
            source: new jqx.dataAdapter(this.sourceScheduler)
          };*/
        let arrApps = this.scheduler.getDataAppointments();
        this.dataAdapter.dataBind();
        arrApps = this.scheduler.getDataAppointments();
        // ALC. appointments are loaded in descendent order
        const lastArrApp = _.first(arrApps);
        // this.scheduler.widgetObject.refresh();
        // @ts-ignore
        this.scheduler.widgetObject.render();
        // jq.render(this.scheduler.widgetObject);
        // $('#alcscheduler').jqxScheduler('render');
        this.scheduler.ensureAppointmentVisible(lastArrApp.id ?? 'id1');
        console.log('ALC. all items received fromm DynamoDB are added to the scheduler. The last added must be visible now.');
        // this.scheduler.showLegend(true);
        // this.scheduler.attrShowLegend = true;
    }
      );
  }
  addAppointmentTask(image: any): void{
    const ticketNumber = image.ticketNumber.N;
    const startDate = image.event.M.ticket.M.timeFrom.S ?? image.updated.S;
    const endDateTimeStamp = (new Date(image.event.M.ticket.M.timeDue.S)).valueOf() ?? (new Date(startDate)).valueOf() + 59 * 60;
    const roomNumber = image.event.M.ticket.M.roomNumber.S;
    const appId = image.id.S; // + (new Date(startDate)).getUTCSeconds();
    const subjectId = 'Ticket #' + ticketNumber;
    const app = {
      id: appId,
      description: `Initiated by ${(image.userId.S ?? 'undefined')}`,
      location: `location ${roomNumber}0`,
      subject: subjectId,
      calendar: 'Room ' + roomNumber,
      start: new Date(startDate),
      end: new Date(endDateTimeStamp)
    };
    // this.sourceScheduler.localData.push(app);
    // this.scheduler.addAppointment(app);
    this.sourceScheduler.localData.push(app);
    // this.sourceScheduler.localData = _.clone(this.sourceScheduler.localData).push(app);
    this.dataAdapter.dataBind();
    // @ts-ignore
    this.scheduler.widgetObject.render();
    // const newDataAdapter =  new jqx.dataAdapter(this.sourceScheduler);
    // // newDataAdapter.localData.push(app);
    // this.dataAdapter = newDataAdapter;
    const apps = this.scheduler.getDataAppointments();
    // this.dataAdapter = new jqx.dataAdapter(this.sourceScheduler);
    // this.scheduler.widgetObject.refresh();
    this.scheduler.ensureAppointmentVisible(app.id); // _.last(apps).id
    // this.scheduler.scrollTop(1500);
    // this.scheduler.showLegend(true);
    // this.scheduler.showToolbar(true);
  }

  ngAfterViewInit(): void {
    // this.scheduler.ensureAppointmentVisible('id1');
    // this.scheduler.theme('dark');
    console.log(`home.component.ts gAfterViewInit this.scheduler= ${this.scheduler}`);
    /*    const subscription = this.subject.subscribe(
          (d) => {
            // this.addAppointment(d);
            console.log(d);
            if (d.Records && d.Records['0'] && d.Records['0'].dynamodb && d.Records['0'].dynamodb.NewImage.id.S !== '-1'){
              // subscription.unsubscribe();
              this.addAppointmentTask(d.Records['0'].dynamodb.NewImage);
            }
          },
          (err) => {
            console.log(err);
          },
          () => {
            console.log('timeticker.dayObserver done');
          }
        );*/

    /*    const subscription = this.timeticker.dayObserver.subscribe(
          (d) => {
            this.addAppointment(d);
            if (d > 0){
              subscription.unsubscribe();
            }
          },
          (err) => {
            console.log(err);
          },
          () => {
            console.log('timeticker.dayObserver done');
          }
        );*/
    // Stop listening for location after 10 seconds
    /*setTimeout(() => {
      objObs.unsubscribe();
    }, 10000);*/

  }
  ngOnInit(): void {
    this.authService.userSubject$.subscribe(this.userObserver);
  }
  ngOnChanges(changes: SimpleChanges): void {
    console.log(`home.component.ts ngOnChanges ${changes}`);
  }

  ngAfterContentInit(): void {
    console.log(`home.component.ts ngAfterContentInit`);
    // ALC. Now connect to the websocket
    this.liveData$.subscribe(
      (d: any) => {
        // this.addAppointment(d);
        console.log(`home.component.ts => websocket data received ${d}`);
        // ALC. If there is no scheduler displayed, nobody can process the update
        if (this.scheduler) {
          _.each(d, (v) => {
            switch (v.eventName) {
              case 'INSERT':
                if (v.dynamodb.NewImage.id.S !== '-1') {// skp counter item, it us updated with every added ticket
                  this.addAppointmentTask(v.dynamodb.NewImage);
                }
                console.log('case INSERT.');
                break;
              case 'REMOVE':
                const appData = this.scheduler.getDataAppointments();
                if (_.find(appData, (item) => item.id === v.dynamodb.Keys.id.S)) {
                  this.removeAppointmentTask(v.dynamodb);
                }
                console.log('case REMOVE.');
                break;
              default:
                console.log(`home.component.ts => Unhandled websocket event ${v}.`);
            }
          });
          // subscription.unsubscribe();
        }
      },
      (err) => {
        console.log(err);
      },
      () => {
        console.log('home.component.ts => liveData$ subscription to messages$ is complete');
      }
    );
    // ALC. [Angular \- NG0100: Expression has changed after it was checked](https://angular.io/errors/NG0100)
    Promise.resolve().then(() => {this.webSocketSubscribers = this.service.getObservers().length; });
    console.log('ALC. now connect to websocket to update new tasks in real time');
    this.service.connect();
  }

  ngAfterViewChecked(): void {
    // console.log(`home.component.ts ngAfterViewChecked`);
    // const sSource =  this.scheduler.source;
    // tslint:disable-next-line:max-line-length
    if (this.calendarDataService.identityAuthorized){
      if (this.scheduler && !this.calendarDataLoaded){
        this.dataAdapter = new jqx.dataAdapter(this.sourceScheduler);
        this.calendarDataLoaded = true;
        this.calendarDataService.getCalendarDataSubject().subscribe(this.calendarDataObserver);
        const awsConfigureDebug = AWS.config.credentials;
        console.log('home.component.ts => AWS.config.credentials');
      }
    } else {
      // ALC Destroy data and subscriptions
      if (!this.scheduler && this.calendarDataLoaded && this.dataAdapter && this.sourceScheduler)
      {
        if (this.scheduler) {
          // this.scheduler.destroy();
        }
        this.calendarDataLoaded = false;
        this.dataAdapter = {};
        this.sourceScheduler.localData = [];
        // ALC. do not close service websocket, only unsubscribe from it
        // this.service.close();
        // this.liveData$.complete();
      }
    }
  }
  removeAppointmentTask(dinamoItem: any): void {
    this.scheduler.deleteAppointment(dinamoItem.Keys.id.S);
  }
  ngOnDestroy(): void {
    // ALC. do not close service websocket, only unsubscribe from it
    // this.service.close();
    this.liveData$.complete();
  }

  ngAfterContentChecked(): void {
    // console.log('home.component.ts => ngAfterContentChecked');
  }
}
